import { StudyGuideViewer } from '@/components/study-guide-viewer/StudyGuideViewer';
import React from 'react';

export default function StudyGuide() {
  return <StudyGuideViewer />;
}
